<template>
  <div
    class="commonTop"
    v-if="this.language == 'eng'"
    style="font-family: 'Times New Roman', Times, serif"
  >
    <!-- pc端 -->
    <div class="computer hidden-xs-only">
      <div class="homeTopList">
        <div class="left eng_left">
          <div class="navbar_dropdown_group" @click="handleChange(1)">
            <router-link to="index" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 1 ? 'selected' : 'sele'"
              >
                Home
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(2)">
            <router-link to="exhibition" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 2 ? 'selected' : 'sele'"
              >
                Regong Works Exhibition
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(4)">
            <router-link to="exhibitionSale" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 4 ? 'selected' : 'sele'"
              >
                Regong Exhibition and Sales
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(5)">
            <router-link to="culture" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 5 ? 'selected' : 'sele'"
              >
                Cultural and Creative Design Exhibition and Sales
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(12)">
            <router-link to="inherit" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 12 ? 'selected' : 'sele'"
              >
                Inheritor
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(3)">
            <router-link to="database" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 3 ? 'selected' : 'sele'"
              >
                Database
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(9)">
            <router-link to="news" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 9 ? 'selected' : 'sele'"
              >
                News Updates
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(10)">
            <router-link to="about" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 10 ? 'selected' : 'sele'"
              >
                About Us
              </div>
            </router-link>
          </div>
          <!-- 热贡作品展搜索 -->
          <div
            class="exhibitionSearch"
            v-if="active == 2"
            @click="handleChange(11)"
          >
            <div class="search">
              <img src="../assets/dataType/search.png" alt />
            </div>
            <div class="iconSearch">[Search]</div>
          </div>
          <!-- 数据库搜索 -->
          <div class="dataBase" v-if="active == 3">
            <div class="goLogin" v-if="!token" @click="goLogin()">
              <span class="userName">
                <div>Account/Login</div>
              </span>
              <span class="userImg">
                <img src="../assets/dataType/login.png" alt />
              </span>
            </div>
            <div class="OutLogin" v-if="token" @click="outLogin()">
              <span class="userName">{{ userName }}</span>
              <span class="userImg">
                <img src="../assets/dataType/login.png" alt />
              </span>
            </div>
            <div class="Search" @click="handleChange(7)">
              <div class="search">
                <img
                  class="searchImg"
                  src="../assets/dataType/search.png"
                  alt
                />
              </div>
              <div class="iconSearch">[Search]</div>
            </div>
          </div>
          <!-- 展销搜索 -->
          <div
            class="exhibitionSearch"
            v-if="active == 4"
            @click="handleChange(6)"
          >
            <div class="search">
              <img src="../assets/dataType/search.png" alt />
            </div>
            <div class="iconSearch">[Search]</div>
          </div>
          <div class="change">
            <el-select :popper-append-to-body="false" popper-class="select-popper" @change="changePCLanguages()" v-model="language" placeholder="请选择">
              <el-option
                v-for="item in languageList"
                :key="item.id"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <div class="menu_mobile hidden-sm-and-up">
      <div class="header_mobile_title">
        <van-icon name="apps-o" class="imgLeft" />
        <div class="eng_title">{{ $route.meta.eng_title }}</div>
        <div class="titleRight">
          <div v-if="active == 3" class="userSearch">
            <!-- 数据库 -->
            <div class="dataBase" v-if="!token">
              <div class="userSearch_Photo" @click="goLogin()">
                <img src="../assets/dataType/login.png" alt />
              </div>
              <div class="userSearch_Search" @click="handleChange(7)">
                <img src="../assets/dataType/search.png" alt />
              </div>
            </div>
            <div class="dataBases" v-if="token">
              <div class="userSearch_Photo" @click="outLogin()">
                <img src="../assets/dataType/login.png" alt />
              </div>
              <div class="userSearch_Search" @click="handleChange(7)">
                <img src="../assets/dataType/search.png" alt />
              </div>
            </div>
          </div>
          <!-- 作品展 -->
          <div
            class="userSearch_saleSearch"
            v-if="active == 2"
            @click="handleChange(11)"
          >
            <img src="../assets/dataType/search.png" alt />
          </div>
          <!-- 展销 -->
          <div
            class="userSearch_saleSearch"
            v-if="active == 4"
            @click="handleChange(8)"
          >
            <img src="../assets/dataType/search.png" alt />
          </div>
        </div>
      </div>
      <!-- 导航栏 -->
      <div class="header_mobile_content" style="display: none">
        <div class="mobile_content_top">
          <span></span>
        </div>
        <div class="change">
          <div class="changeBox">
            <div
              @click="changeLanguages(1)"
              :class="language == 'en' ? 'select' : ''"
              class="zang"
            >
              བོད་ཡིག །
            </div>
            <div
              @click="changeLanguages(2)"
              :class="language == 'cn' ? 'select' : ''"
              class="chinese"
            >
              中文
            </div>
            <div
              @click="changeLanguages(3)"
              :class="language == 'eng' ? 'select' : ''"
              class="chinese eng"
              style="font-family: 'Times New Roman', Times, serif"
            >
              English
            </div>
          </div>
        </div>
        <div class="mobile_content_middle">
          <div>
            <div @click="handleChange(1)">
              <router-link to="index">
                <div>Home</div>
              </router-link>
            </div>
            <div @click="handleChange(2)">
              <router-link to="exhibition">
                <div>Regong Works Exhibition</div>
              </router-link>
            </div>
            <div @click="handleChange(4)">
              <router-link to="exhibitionSale">
                <div>Regong Exhibition and Sales</div>
              </router-link>
            </div>
            <div @click="handleChange(5)">
              <router-link to="culture">
                <div>Cultural and Creative Design Exhibition and Sales</div>
              </router-link>
            </div>
            <div @click="handleChange(12)">
              <router-link to="inherit">
                <div>Inheritor</div>
              </router-link>
            </div>
            <div @click="handleChange(3)">
              <router-link to="database">
                <div>Database</div>
              </router-link>
            </div>
            <div @click="handleChange(9)">
              <router-link to="news">
                <div>News Updates</div>
              </router-link>
            </div>
            <div @click="handleChange(10)">
              <router-link to="about">
                <div>About Us</div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="Login"
      :visible.sync="loginDialogVisible"
      class="loginDialogVisible"
      width="30%"
    >
      <el-form :model="ruleForm" :rules="eng_rules" ref="ruleForm">
        <el-form-item prop="username">
          <el-input
            type="phone"
            v-model="ruleForm.username"
            placeholder="Please enter an account"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            v-model="ruleForm.password"
            placeholder="Please input a password"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <div class="sure" @click="loginButton('ruleForm')">OK</div>
        <div class="cannel" @click="loginDialogVisible = false">Cancel</div>
      </span>
    </el-dialog>
    <el-dialog
      title="确定退出当前账号吗"
      :visible.sync="outloginDialogVisible"
      class="outloginDialogVisible"
      width="30%"
    >
      <span slot="footer" class="dialog-footer">
        <div class="sure" @click="outloginButton()">OK</div>
        <div class="cannel" @click="outloginDialogVisible = false">Cancel</div>
      </span>
    </el-dialog>
  </div>
  <div class="commonTop" v-else-if="this.language == 'en'">
    <div class="computer hidden-xs-only">
      <div class="homeTopList">
        <div class="left za_left">
          <div class="navbar_dropdown_group group_one" @click="handleChange(1)">
            <router-link to="index" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 1 ? 'selected' : 'sele'"
              >
                ངོ་བྱང་།
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(2)">
            <router-link to="exhibition" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 2 ? 'selected' : 'sele'"
              >
                རེབ་གོང་བརྩམས་ཆོས་འགྲེམ་སྤེལ།
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(4)">
            <router-link to="exhibitionSale" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 4 ? 'selected' : 'sele'"
              >
                རེབ་གོང་བརྩམས་ཆོས་འགྲེམ་འཚོང་།
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(5)">
            <router-link to="culture" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 5 ? 'selected' : 'sele'"
              >
                རིག་གཏོད་ཇུས་འགོད་དང་འགྲེམ་འཚོང་།
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(12)">
            <router-link to="inherit" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 12 ? 'selected' : 'sele'"
              >
                རྒྱུན་འཛིན་པ།
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(3)">
            <router-link to="database" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 3 ? 'selected' : 'sele'"
              >
                གྲངས་མཛོད།
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(9)">
            <router-link to="news" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 9 ? 'selected' : 'sele'"
              >
                གསར་འགྱུར་གྱི་གནས་ཚུལ།
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(10)">
            <router-link to="about" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 10 ? 'selected' : 'sele'"
              >
                ང་ཚོའི་སྐོར།
              </div>
            </router-link>
          </div>
          <!-- 热贡作品展搜索 -->
          <div
            class="exhibitionSearch"
            v-if="active == 2"
            @click="handleChange(11)"
          >
            <div class="search">
              <img src="../assets/dataType/search.png" alt />
            </div>
            <div class="iconSearch">[འཚོལ་བཤེར།]</div>
          </div>
          <!-- 数据库搜索 -->
          <div class="dataBase" v-if="active == 3">
            <div class="goLogin" v-if="!token" @click="goLogin()">
              <span class="userName">
                <div>ཐོ་ཨང/ཇུས་འགོད།</div>
              </span>
              <span class="userImg">
                <img src="../assets/dataType/login.png" alt />
              </span>
            </div>
            <div class="OutLogin" v-if="token" @click="outLogin()">
              <span class="userName">{{ userName }}</span>
              <span class="userImg">
                <img src="../assets/dataType/login.png" alt />
              </span>
            </div>
            <div class="Search" @click="handleChange(7)">
              <div class="search">
                <img
                  class="searchImg"
                  src="../assets/dataType/search.png"
                  alt
                />
              </div>
              <div class="iconSearch">[ འཚོལ་བཤེར། ]</div>
            </div>
          </div>
          <!-- 展销搜索 -->
          <div
            class="exhibitionSearch"
            v-if="active == 4"
            @click="handleChange(6)"
          >
            <div class="search">
              <img src="../assets/dataType/search.png" alt />
            </div>
            <div class="iconSearch">[འཚོལ་བཤེར།]</div>
          </div>
          <div class="change">
            <el-select :popper-append-to-body="false" popper-class="select-popper" @change="changePCLanguages()" v-model="language" placeholder="请选择">
              <el-option
                v-for="item in languageList"
                :key="item.id"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <div class="menu_mobile hidden-sm-and-up">
      <div class="header_mobile_title">
        <van-icon name="apps-o" class="imgLeft" />
        <h2>{{ $route.meta.za_title }}</h2>
        <div class="titleRight">
          <div v-if="active == 3" class="userSearch">
            <!-- 数据库 -->
            <div class="dataBase" v-if="!token">
              <div class="userSearch_Photo" @click="goLogin()">
                <img src="../assets/dataType/login.png" alt />
              </div>
              <div class="userSearch_Search" @click="handleChange(7)">
                <img src="../assets/dataType/search.png" alt />
              </div>
            </div>
            <div class="dataBases" v-if="token">
              <div class="userSearch_Photo" @click="outLogin()">
                <img src="../assets/dataType/login.png" alt />
              </div>
              <div class="userSearch_Search" @click="handleChange(7)">
                <img src="../assets/dataType/search.png" alt />
              </div>
            </div>
          </div>
          <!-- 作品展 -->
          <div
            class="userSearch_saleSearch"
            v-if="active == 2"
            @click="handleChange(11)"
          >
            <img src="../assets/dataType/search.png" alt />
          </div>
          <!-- 展销 -->
          <div
            class="userSearch_saleSearch"
            v-if="active == 4"
            @click="handleChange(8)"
          >
            <img src="../assets/dataType/search.png" alt />
          </div>
        </div>
      </div>
      <!-- 导航栏 -->
      <div class="header_mobile_content" style="display: none">
        <div class="mobile_content_top">
          <span></span>
        </div>
        <div class="change">
          <div class="changeBox">
            <div
              @click="changeLanguages(1)"
              :class="language == 'en' ? 'select' : ''"
              class="zang"
            >
              བོད་ཡིག །
            </div>
            <div
              @click="changeLanguages(2)"
              :class="language == 'cn' ? 'select' : ''"
              class="chinese"
            >
              中文
            </div>
            <div
              @click="changeLanguages(3)"
              :class="language == 'eng' ? 'select' : ''"
              class="chinese eng"
              style="font-family: 'Times New Roman', Times, serif"
            >
              English
            </div>
          </div>
        </div>
        <div class="mobile_content_middle">
          <div>
            <div @click="handleChange(1)">
              <router-link to="index">
                <div>ངོ་བྱང་།</div>
              </router-link>
            </div>
            <div @click="handleChange(2)">
              <router-link to="exhibition">
                <div>རེབ་གོང་བརྩམས་ཆོས་འགྲེམ་སྤེལ།</div>
              </router-link>
            </div>
            <div @click="handleChange(4)">
              <router-link to="exhibitionSale">
                <div>རེབ་གོང་བརྩམས་ཆོས་འགྲེམ་འཚོང་།</div>
              </router-link>
            </div>
            <div @click="handleChange(5)">
              <router-link to="culture">
                <div>རིག་གཏོད་ཇུས་འགོད་དང་འགྲེམ་འཚོང་།</div>
              </router-link>
            </div>
            <div @click="handleChange(12)">
              <router-link to="inherit">
                <div>རྒྱུན་འཛིན་པ།</div>
              </router-link>
            </div>
            <div @click="handleChange(3)">
              <router-link to="database">
                <div>གྲངས་མཛོད།</div>
              </router-link>
            </div>
            <div @click="handleChange(9)">
              <router-link to="news">
                <div>གསར་འགྱུར་གྱི་གནས་ཚུལ།</div>
              </router-link>
            </div>
            <div @click="handleChange(10)">
              <router-link to="about">
                <div>ང་ཚོའི་སྐོར།</div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="ཐོ་འགོད།"
      :visible.sync="loginDialogVisible"
      class="loginDialogVisible"
      width="30%"
    >
      <el-form :model="ruleForm" :rules="za_rules" ref="ruleForm">
        <el-form-item prop="username">
          <el-input
            type="phone"
            v-model="ruleForm.username"
            placeholder="ཐོ་ཨང་འཇུག་རོགས། "
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            v-model="ruleForm.password"
            placeholder="གསང་གྲངས་འཇུག་རོགས།"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <div class="sure" @click="loginButton('ruleForm')">ཡིན་ཆོད།</div>
        <div class="cannel" @click="loginDialogVisible = false">མེད་བཟོ།</div>
      </span>
    </el-dialog>
    <el-dialog
      title="མིག་སྔའི་ཐོ་ཁོངས་ནས་ཕྱིར་འཐེན་གཏན་ཁེལ།"
      :visible.sync="outloginDialogVisible"
      class="outloginDialogVisible"
      width="30%"
    >
      <span slot="footer" class="dialog-footer">
        <div class="sure" @click="outloginButton()">ཡིན་ཆོད།</div>
        <div class="cannel" @click="outloginDialogVisible = false">
          མེད་བཟོ།
        </div>
      </span>
    </el-dialog>
  </div>
  <div class="commonTop" v-else>
    <!-- pc端 -->
    <div class="computer hidden-xs-only">
      <div class="homeTopList">
        <div class="left">
          <div class="navbar_dropdown_group" @click="handleChange(1)">
            <router-link to="index" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 1 ? 'selected' : 'sele'"
              >
                首页
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(2)">
            <router-link to="exhibition" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 2 ? 'selected' : 'sele'"
              >
                热贡作品展
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(4)">
            <router-link to="exhibitionSale" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 4 ? 'selected' : 'sele'"
              >
                热贡作品展销
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(5)">
            <router-link to="culture" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 5 ? 'selected' : 'sele'"
              >
                文创设计与展销
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(12)">
            <router-link to="inherit" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 12 ? 'selected' : 'sele'"
              >
                传承人
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(3)">
            <router-link to="database" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 3 ? 'selected' : 'sele'"
              >
                数据库
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(9)">
            <router-link to="news" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 9 ? 'selected' : 'sele'"
              >
                新闻动态
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(10)">
            <router-link to="about" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 10 ? 'selected' : 'sele'"
              >
                关于我们
              </div>
            </router-link>
          </div>
          <!-- 热贡作品展搜索 -->
          <div
            class="exhibitionSearch"
            v-if="active == 2"
            @click="handleChange(11)"
          >
            <div class="search">
              <img src="../assets/dataType/search.png" alt />
            </div>
            <div class="iconSearch">[搜索]</div>
          </div>
          <!-- 数据库搜索 -->
          <div class="dataBase" v-if="active == 3">
            <div class="goLogin" v-if="!token" @click="goLogin()">
              <span class="userName">
                <div>账号/登录</div>
              </span>
              <span class="userImg">
                <img src="../assets/dataType/login.png" alt />
              </span>
            </div>
            <div class="OutLogin" v-if="token" @click="outLogin()">
              <span class="userName">{{ userName }}</span>
              <span class="userImg">
                <img src="../assets/dataType/login.png" alt />
              </span>
            </div>
            <div class="Search" @click="handleChange(7)">
              <div class="search">
                <img
                  class="searchImg"
                  src="../assets/dataType/search.png"
                  alt
                />
              </div>
              <div class="iconSearch">[搜索]</div>
            </div>
          </div>
          <!-- 展销搜索 -->
          <div
            class="exhibitionSearch"
            v-if="active == 4"
            @click="handleChange(6)"
          >
            <div class="search">
              <img src="../assets/dataType/search.png" alt />
            </div>
            <div class="iconSearch">[搜索]</div>
          </div>
          <div class="change">
            <el-select :popper-append-to-body="false" popper-class="select-popper" @change="changePCLanguages()" v-model="language" placeholder="请选择">
              <el-option
                v-for="item in languageList"
                :key="item.id"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <div class="menu_mobile hidden-sm-and-up">
      <div class="header_mobile_title">
        <van-icon name="apps-o" class="imgLeft" />
        <h2>{{ $route.meta.title }}</h2>
        <div class="titleRight">
          <div v-if="active == 3" class="userSearch">
            <!-- 数据库 -->
            <div class="dataBase" v-if="!token">
              <div class="userSearch_Photo" @click="goLogin()">
                <img src="../assets/dataType/login.png" alt />
              </div>
              <div class="userSearch_Search" @click="handleChange(7)">
                <img src="../assets/dataType/search.png" alt />
              </div>
            </div>
            <div class="dataBases" v-if="token">
              <div class="userSearch_Photo" @click="outLogin()">
                <img src="../assets/dataType/login.png" alt />
              </div>
              <div class="userSearch_Search" @click="handleChange(7)">
                <img src="../assets/dataType/search.png" alt />
              </div>
            </div>
          </div>
          <!-- 作品展 -->
          <div
            class="userSearch_saleSearch"
            v-if="active == 2"
            @click="handleChange(11)"
          >
            <img src="../assets/dataType/search.png" alt />
          </div>
          <!-- 展销 -->
          <div
            class="userSearch_saleSearch"
            v-if="active == 4"
            @click="handleChange(8)"
          >
            <img src="../assets/dataType/search.png" alt />
          </div>
          <!-- <div v-else class="nothing"></div> -->
        </div>
      </div>
      <!-- 导航栏 -->
      <div class="header_mobile_content" style="display: none">
        <div class="mobile_content_top">
          <span></span>
        </div>
        <div class="change">
          <div class="changeBox">
            <div
              @click="changeLanguages(1)"
              :class="language == 'en' ? 'select' : ''"
              class="zang"
            >
              བོད་ཡིག །
            </div>
            <div
              @click="changeLanguages(2)"
              :class="language == 'cn' || num == 1 ? 'select' : ''"
              class="chinese"
            >
              中文
            </div>
            <div
              @click="changeLanguages(3)"
              :class="language == 'eng' ? 'select' : ''"
              class="chinese eng"
              style="font-family: 'Times New Roman', Times, serif"
            >
              English
            </div>
          </div>
        </div>
        <div class="mobile_content_middle">
          <div>
            <div @click="handleChange(1)">
              <router-link to="index">
                <div>首页</div>
              </router-link>
            </div>
            <div @click="handleChange(2)">
              <router-link to="exhibition">
                <div>热贡作品展</div>
              </router-link>
            </div>
            <div @click="handleChange(4)">
              <router-link to="exhibitionSale">
                <div>热贡作品展销</div>
              </router-link>
            </div>
            <div @click="handleChange(5)">
              <router-link to="culture">
                <div>文创设计与展销</div>
              </router-link>
            </div>
            <div @click="handleChange(12)">
              <router-link to="inherit">
                <div>传承人</div>
              </router-link>
            </div>
            <div @click="handleChange(3)">
              <router-link to="database">
                <div>数据库</div>
              </router-link>
            </div>
            <div @click="handleChange(9)">
              <router-link to="news">
                <div>新闻动态</div>
              </router-link>
            </div>
            <div @click="handleChange(10)">
              <router-link to="about">
                <div>关于我们</div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="登录"
      :visible.sync="loginDialogVisible"
      class="loginDialogVisible"
      width="30%"
    >
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item prop="username">
          <el-input
            type="phone"
            v-model="ruleForm.username"
            placeholder="请输入账号"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            v-model="ruleForm.password"
            placeholder="请输入密码"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <div class="sure" @click="loginButton('ruleForm')">确 定</div>
        <div class="cannel" @click="loginDialogVisible = false">取 消</div>
      </span>
    </el-dialog>
    <el-dialog
      title="确定退出当前账号吗"
      :visible.sync="outloginDialogVisible"
      class="outloginDialogVisible"
      width="30%"
    >
      <span slot="footer" class="dialog-footer">
        <div class="sure" @click="outloginButton()">确 定</div>
        <div class="cannel" @click="outloginDialogVisible = false">取 消</div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { login } from "../api/management.js";
import { userInfo, logout } from "../api/management";
export default {
  computed: {
    myValue() {
      return this.$store.state.num;
    },
    changeLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    myValue: function (val) {
      this.active = val;
    },
    rightTitle: function (val) {
      this.dream = val;
    },
    changeLanguage: function (val) {
      this.language = val;
    },
    "$route.path": {
      handler(toPath, fromPath) {
        if (toPath == "/index") {
          this.active = 1;
        } else if (
          toPath == "/exhibition" ||
          toPath == "/exhibitionDetail" ||
          toPath == "/exhibitionWorkDetail" ||
          toPath == "/paintingExhibition" ||
          toPath == "/exhibitionWork" ||
          toPath == "/exhibitionBaseDetail" ||
          toPath == "/exhibitionSearch" ||
          toPath == "/exhibitionSearchDetails"
        ) {
          this.active = 2;
        } else if (
          toPath == "/exhibitionSale" ||
          toPath == "/exhibitionSearchDetail" ||
          toPath == "/exhibitionMade" ||
          toPath == "/exhibitionSaleSearchDetail" ||
          toPath == "/exhibitionSaleSearch"
        ) {
          this.active = 4;
        } else if (
          toPath == "/culture" ||
          toPath == "/culturalGoodsDetail" ||
          toPath == "/culturalMoreGoods" ||
          toPath == "/culturalCustomMade" ||
          toPath == "/culturalCustomSearchDetail" ||
          toPath == "/culturalCustomDetail"
        ) {
          this.active = 5;
        } else if (
          toPath == "/database" ||
          toPath == "/dataBaseWork" ||
          toPath == "/dataBaseDetail" ||
          toPath == "/dataBaseSearchDetail" ||
          toPath == "/dataBaseSearch"
        ) {
          this.active = 3;
        } else if (toPath == "/news" || toPath == "/newsDetail") {
          this.active = 9;
        } else if (toPath == "/about") {
          this.active = 10;
        } else if (toPath == "/inheritDetail" || toPath == "/inherit") {
          this.active = 12;
        }
      },
      deep: true, // 深度监听
      immediate: true, // 第一次初始化渲染就可以监听到
    },
  },
  data() {
    return {
      num: 1,
      active: 1,
      token: localStorage.getItem("token"),
      userName: localStorage.getItem("userName"),
      hotArt: "热贡艺术",
      dream: this.$store.state.rightTitle
        ? this.$store.state.rightTitle
        : "美梦成真",
      loginDialogVisible: false,
      outloginDialogVisible: false,
      ruleForm: {
        username: "",
        password: "",
      },
      rules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      eng_rules: {
        username: [
          {
            required: true,
            message: "Please enter the account number",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "Please enter the password",
            trigger: "blur",
          },
        ],
      },
      za_rules: {
        username: [
          {
            required: true,
            message: "ཨང་གྲངས་ནང་འཇུག་བྱེད་རོགས།",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "གསང་གྲངས་ནང་འཇུག་བྱེད་རོགས།",
            trigger: "blur",
          },
        ],
      },
      language: this.$store.state.language, //防止动态刷新导致头部重新变化
      languageList:[
        {
          id:1,
          value: 'cn',
          label: '中文'
        },
        {
          id:2,
          value: 'en',
          label: 'བོད་ཡིག །'
        },
        {
          id:3,
          value: 'eng',
          label: 'English'
        }
      ]
    };
  },
  mounted() {
    this.initDropDown();
  },
  methods: {
    getToken() {
      this.token = localStorage.getItem("token");
    },
    goLogin() {
      this.loginDialogVisible = true;
    },
    // 手机
    initDropDown() {
      $(".header_mobile_title .imgLeft").click(function () {
        $(".header_mobile_content").animate({ width: "toggle" }, 300);
      });
      $(".mobile_content_top span").click(function () {
        $(".header_mobile_content").animate({ width: "toggle" }, 300);
      });
      $(".header_mobile_content a").click(function () {
        $(".header_mobile_content").hide();
      });
      $(".header_mobile_content .changeBox div").click(function () {
        $(".mobile_content_top span").click(function () {
          $(".header_mobile_content").animate({ width: "toggle" }, 300);
        });
      });
    },
    handleChange(num) {
      if (num == 2) {
        // this.$store.commit("changeTitle", "美梦成真");
      } else if (num == 1) {
        // this.$store.commit("changeTitle", "殿堂大师作品展");
      } else if (num == 3) {
        // this.$store.commit("changeTitle", "热贡泥塑数据库");
        this.getToken();
      } else if (num == 4) {
        // this.$store.commit("changeTitle", "名家作品展销");
      } else if (num == 5) {
        // this.$store.commit("changeTitle", "AI辅助文创定制");
      } else if (num == 6) {
        this.$router.push("/exhibitionSaleSearch");
      } else if (num == 7) {
        let token = localStorage.getItem("token");
        if (token) {
          this.$router.push("/dataBaseSearch");
        } else {
          this.$message.error("未登录");
        }
      } else if (num == 8) {
        // this.$store.commit("changeTitle", "名家作品展销");
        this.$router.push("/exhibitionSaleSearch");
      } else if (num == 9) {
        // this.$store.commit("changeNum", num);
      } else if (num == 10) {
        // this.$store.commit("changeNum", num);
      } else if (num == 11) {
        this.$router.push("/exhibitionSearch");
      }
    },
    //登录
    loginButton(ruleForm) {
      this.$refs[ruleForm].validate(async (valid) => {
        if (valid) {
          const res = await login(
            {
              p1:this.ruleForm.username,
              p2:this.ruleForm.password,
            }
          );
          let token = res.data;
          this.token = res.data;
          localStorage.setItem("token", token);
          this.loginDialogVisible = false;
          if (res.code == 1) {
            this.$message({
              message: "登录成功",
              type: "success",
            });
            this.getUserInfo();
          }
        } else {
          return false;
        }
      });
    },
    // 获取用户个人信息
    async getUserInfo() {
      const res = await userInfo();
      this.userName = res.data.username;
      let name = res.data.username;
      localStorage.setItem("userName", name);
    },
    outLogin() {
      this.outloginDialogVisible = true;
    },
    async outloginButton() {
      const res = await logout();
      if (res.code == 1) {
        this.$message({
          message: "退出成功",
          type: "success",
        });
        this.token = null;
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("userName");
      }
      this.outloginDialogVisible = false;
    },
    changeLanguages(num) {
      if (num == 2) {
        this.language = "cn";
        this.$store.commit("changeLanguage", this.language);
      } else if (num == 1) {
        this.language = "en";
        this.$store.commit("changeLanguage", this.language);
      } else if (num == 3) {
        this.language = "eng";
        this.$store.commit("changeLanguage", this.language);
      }
    },
    changePCLanguages() {
      let language = this.language
      this.$store.commit("changeLanguage", language);
    }
  },
};
</script>
<style lang="scss">
.commonTop {
  width: 100%;
  .iconSearch {
    color: #fff;
  }
  .computer {
    width: 100%;
    position: relative;
    .homeTopList {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 999;
      text-align: center;
      display: flex;
      width: 100%;
      height: 50px;
      background-color: #10161e;
      opacity: 0.9;
      justify-content: center;
      .left {
        font-family: "fangzang";
        width: 100%;
        height: 50px;
        display: flex;
        white-space: nowrap;
        justify-content: center;
        .navbar_dropdown_group {
          margin-left: 0.3rem;
          // padding: 0 20px;
          a {
            display: inline-block;
            text-align: center;
            font-size: 16px;
            color: #fff;
            transition: all 0.3s ease;
            &:hover {
              color: #feae03;
            }
            .tarbar_title {
              height: 50px;
              line-height: 50px;
            }
          }
          .tar {
            .tarbar_title {
              border-bottom: 0;
            }
            .selected {
              border-bottom: 4px solid #ed201a;
            }
          }
          //记住切不可将router-link-exact-active与tar调换位置
          .router-link-exact-active {
            .selected {
              border-bottom: 4px solid #ed201a;
            }
          }
        }
        .navbar_dropdown_group:first-child {
          margin-left: 0;
        }
        .dataBase {
          cursor: pointer;
          font-size: 16px;
          margin-left: 0.1rem;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #fff;
          img {
            vertical-align: middle;
          }
          .goLogin {
            display: flex;
            justify-content: center;
            align-items: center;
            padding-right: 15px;
            .userImg {
              position: relative;
              margin-left: 15px;
              display: flex;
              justify-content: center;
              align-items: center;
              height: 30px;
              width: 30px;
              background-color: #931217;
              border-radius: 100%;
              .loginBox {
                display: none;
              }
            }
            .userImg:hover {
              .loginBox {
                border-radius: 4px;
                display: block;
                position: absolute;
                top: 30px;
                left: -8px;
                width: 48px;
                height: 32px;
                background-color: #fff;
                font-size: 14px;
                color: #10161e;
                font-family: none;
                .loginBox_top {
                  text-align: center;
                  padding: 6px 0;
                }
                .loginBox_bottom {
                  text-align: center;
                  padding: 6px 0;
                }
              }
            }
          }
          .OutLogin {
            display: flex;
            justify-content: center;
            align-items: center;
            .userImg {
              position: relative;
              margin: 0 15px;
              display: flex;
              justify-content: center;
              align-items: center;
              height: 30px;
              width: 30px;
              background-color: #971118;
              border-radius: 100%;
              .loginBox {
                display: none;
              }
            }
            .userImg:hover {
              .loginBox {
                border-radius: 4px;
                display: block;
                position: absolute;
                top: 30px;
                left: -8px;
                width: 48px;
                height: 32px;
                background-color: #fff;
                font-size: 14px;
                color: #10161e;
                font-family: none;
                .loginBox_top {
                  text-align: center;
                  padding: 6px 0;
                }
                .loginBox_bottom {
                  text-align: center;
                  padding: 6px 0;
                }
              }
            }
          }
          .Search {
            display: flex;
            .search {
              display: flex;
              justify-content: center;
              align-items: center;
              height: 30px;
              width: 30px;
              background-color: #971118;
              border-radius: 100%;
            }
            .iconSearch {
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
        }
        .exhibitionSearch {
          margin-left: 0.1rem;
          display: flex;
          font-size: 13px;
          align-items: center;
          .search {
            line-height: 60px;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 30px;
            width: 30px;
            background-color: #971118;
            border-radius: 100%;
          }
          .iconSearch {
            line-height: 30px;
          }
        }
        .change {
          margin-left: 0.1rem;
          display: flex;
          align-items: center;
          .el-select {
            width: 90px;
            height: 30px;
            .el-input {
              .el-input__inner{
                height: 30px;
                text-align: center;
                background-color: #550a0d;
                border: none;
                color: #fff;
              }
              .el-input__suffix{
                .el-input__suffix-inner{
                  .el-select__caret{
                    color: #fff;
                  }
                  .el-input__icon {
                    height: 30px;
                    line-height: 30px;
                  }
                }
              }
            }
            .select-popper {
              .el-scrollbar {
                .el-select-dropdown__wrap{
                  .el-scrollbar__view {
                    .selected{
                      color: #550a0d;
                    }
                  }
                }

              }
            }
          }
        }
      }
      .za_left {
        // left: 8%;
        .navbar_dropdown_group {
          margin-left: 0.1rem;
          a {
            font-size: 18px;
          }
        }
        .dataBase {
          margin-left: .1rem;
        }
      }
      .eng_left {
        font-family: "Times New Roman", Times, serif;
        // left: 9%;
        .navbar_dropdown_group {
          margin-left: 0.1rem;
          a {
            font-size: 13px;
          }
        }
        .dataBase {
          margin-left: .1rem;
          font-size: 13px;
        }
        .change{
          margin-left: .1rem;
          .changeBox {
            font-family: "fangzang";
          }
        }
      }
    }
  }
  .loginDialogVisible,
  .outloginDialogVisible {
    .el-dialog {
      padding: 40px 0 0;
    }
    .el-dialog__header {
      padding: 0px 20px 20px;
      text-align: center;
      .el-dialog__headerbtn {
        display: none;
      }
    }
    .el-dialog__body {
      padding: 0 70px 15px 70px;
      .el-form {
        .el-form-item {
          .el-form-item__content {
            .el-input {
              .el-input__inner {
                border: none;
                border-bottom: 1px solid #eeeeee;
                height: 50px;
              }
              // 改变input框背景颜色
              input:-webkit-autofill {
                text-align: center;
                background-color: transparent;
                background-image: none;
                transition: background-color 50000s ease-in-out 0s; //背景色透明  生效时长  过渡效果  启用时延迟的时间
              }
              input {
                text-align: center;

                background-color: transparent;
              }
            }
          }
        }
      }
    }
    .el-dialog__footer {
      display: flex;
      justify-content: center;
      .dialog-footer {
        display: flex;
        justify-content: center;
        div {
          font-size: 16px;
          height: 36px;
          width: 70px;
          text-align: center;
          line-height: 36px;
          border-radius: 4px;
          cursor: pointer;
        }
        .sure {
          background-color: #971118;
          color: #fff;
          margin-right: 30px;
        }
        .cannel {
          background-color: #e6e6e6;
          color: #a19c90;
        }
      }
    }
  }
  .menu_mobile {
    z-index: 9999;
    .header_mobile_title {
      height: 1.1rem;
      box-shadow: 0 2px 2px #d8d9da;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      padding: 0 0.1rem;
      img {
        width: 0.5rem;
        height: 0.5rem;
      }
      h2 {
        text-align: center;
        font-weight: 400;
        font-size: 0.345rem;
      }
      span {
        width: 0.5rem;
        height: 0.5rem;
      }
      .titleRight {
        min-width: 0.5rem;
        height: 0.5rem;
        .userSearch {
          .dataBase {
            display: flex;
            .userSearch_Photo {
              width: 0.5rem;
              height: 0.5rem;
              background-color: #dee0ed;
              border-radius: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              img {
                width: 0.25rem;
                height: 0.3rem;
              }
            }
            .userSearch_Search {
              margin-left: 0.2rem;
              width: 0.5rem;
              height: 0.5rem;
              background-color: #971118;
              border-radius: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              img {
                width: 0.3rem;
                height: 0.3rem;
              }
            }
          }
          .dataBases {
            display: flex;
            .userSearch_Photo {
              width: 0.5rem;
              height: 0.5rem;
              background-color: #971118;
              border-radius: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              img {
                width: 0.25rem;
                height: 0.3rem;
              }
            }
            .userSearch_Search {
              margin-left: 0.2rem;
              width: 0.5rem;
              height: 0.5rem;
              background-color: #971118;
              border-radius: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              img {
                width: 0.3rem;
                height: 0.3rem;
              }
            }
          }
        }
        .userSearch_saleSearch {
          // margin-left: 0.2rem;
          width: 0.5rem;
          height: 0.5rem;
          background-color: #971118;
          border-radius: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 0.3rem;
            height: 0.3rem;
          }
        }
        .nothing {
          width: 0.5rem;
          height: 0.5rem;
        }
      }
    }
    .header_mobile_content {
      position: fixed;
      top: 0;
      background: rgba(65, 120, 190, 0.8);
      width: 100vw;
      height: 100vh;
      z-index: 9999;
      .mobile_content_top {
        height: 1.2rem;
        display: flex;
        align-items: center;
        flex-direction: row-reverse;
        width: 100%;
        span {
          padding-right: 1rem;
          display: inline-block;
          width: 0.4rem;
          height: 0.4rem;
          background: url("../assets/mobile/cancle.png") center center no-repeat;
          transform: rotate(180deg);
        }
      }
      .mobile_content_middle {
        display: flex;
        justify-content: center;
        flex-direction: column;
        a {
          display: block;
          padding: 0 0.25rem;
          font-size: 0.31rem;
          color: #fff;
          text-align: center;
          margin-bottom: 0.3rem;
          .chinese,
          .zang {
            font-size: 0.25rem;
          }
        }
      }
      .change {
        margin-left: 50%;
        transform: translateX(-30%);
        margin-bottom: 0.2rem;
        .changeBox {
          width: 3rem;
          display: flex;
          .zang {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 3px 5px;
            background-color: #fff;
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
            cursor: pointer;
          }
          .chinese {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 3px 5px;
            background-color: #fff;

            cursor: pointer;
          }
          .eng {
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
          }
          .select {
            background-color: #731c2c;
            color: #fff;
          }
        }
      }
    }
  }
}
@media (max-width: 768px) {
  .commonTop {
    .header_mobile_title {
      .imgLeft {
        color: #931217;
        font-size: 22px;
      }
      .eng_title {
        font-size: 16px;
        width: 100%;
        text-align: center;
      }
    }
    .header_mobile_content {
      .change {
        transform: translateX(-46%) !important;
        .changeBox {
          width: 3.6rem !important;
        }
        .changeBox > div {
          padding: 0.06rem !important;
          width: 1rem;
        }
        .changeBox {
          .zang,
          .eng {
            width: 1.2rem;
          }
        }
      }
    }
    .eng {
      width: 60px;
      line-height: 27px;
      text-align: center;
    }
    .el-dialog {
      padding: 0 !important;
      .el-dialog__header {
        padding: 20px 20px 0px;
        text-align: center;
        .el-dialog__headerbtn {
          display: none;
        }
      }
      width: 70% !important;
      .el-dialog__body {
        padding: 0 0.6rem;
      }
      .register {
        text-align: right;
      }
    }
  }
}
</style>
